// extracted by mini-css-extract-plugin
export default {"modal":"classes_modal__YnXPm","suggestContainer":"classes_suggestContainer__rT6sQ","suggestInput":"classes_suggestInput__lvueR"};